<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/toast" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">提示框</div>
        <div class="sub-title">纯文字</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">带图标</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>

        <div class="sub-title">不同状态</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>


      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-text>
    <yu-button fluid @click="activeToast('one')">纯文字</yu-button>
  </yu-text>
  <yu-toast ref="one" content="纯文字"/>
      `,
      code2: `
  import { YuToast, YuText, YuButton } from 'yu.mobile';

  export default {
    name: 'HelloWorld',
    methods: {
      activeToast(item) {
        this.$refs[item].show();
      },
    },
    components: {
      YuButton,
      YuToast,
      YuText,
    },
  };
      `,
      code3: `
  <yu-toast ref="two" content="带图标" icon="icon-check"/>
      `,
      code4: `
  <yu-toast ref="three" content="不同状态" status="success"/>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'icon',
          description: '图标class',
          types: 'String',
          default: '无',
        },
        {
          prop: 'status',
          description: '不同状态[success,fail,offline,loading]',
          types: 'String',
          default: '无',
        },
        {
          prop: 'time',
          description: '显示时长,毫秒',
          types: 'Number',
          default: '2000',
        },
        {
          prop: 'statusIcon',
          description: '不同状态的默认图标，可更换',
          types: 'Object',
          default: '{\n' +
          '        success: \'icon-check-circle\',\n' +
          '        fail: \'icon-close-circle\',\n' +
          '        offline: \'icon-sad\',\n' +
          '        loading: \'icon-loading\',\n' +
          '      }',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toast.vue